import React from 'react'

export default class PartnerItem extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<a href="">
				<img src={this.props.src} alt="" width="180" />
			</a>
		)
	}
}